export const makeStringWithAnd = (arr: string[]) => {
  if (!arr || arr.length === 0) return
  if (arr.length === 1) return arr[0]
  const firsts = arr.slice(0, arr.length - 1)
  const last = arr[arr.length - 1]
  return firsts.join(', ') + ' e ' + last
}
